import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderService } from '../../../shared/components/loader/loader.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  public apiUrl;

  constructor(private _http: HttpClient, private loaderService: LoaderService) {
    this.apiUrl = environment.apiUrl;
  }

  private setHeaders(): HttpHeaders {
    const headersConfig = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    return new HttpHeaders(headersConfig);
  }

  // POST
  apipost(apiurl: string, postdata: any = {}, showLoader = false) {
    if (showLoader) {
      this.loaderService.show();
    }
    return this._http.post(`${this.apiUrl}${apiurl}`, postdata, {
      headers: this.setHeaders()
    });
  }

  // PUT
  apiput(apiurl: string, putdata: any = {}, showLoader = false) {
    if (showLoader) {
      this.loaderService.show();
    }
    return this._http.put(`${this.apiUrl}${apiurl}`, putdata, {
      headers: this.setHeaders()
    });
  }

  // GET
  apiget(apiurl: string, params: any = {}, showLoader = false) {
    if (showLoader) {
      this.loaderService.show();
    }
    return this._http.get(`${this.apiUrl}${apiurl}`, {
      headers: this.setHeaders(),
      params
    });
  }
}